<template>
	<button
		class="sidenav__toggle"
		:aria-label="isSideNavOpen ? ariaCloseSideNav : ariaOpenSideNav"
		@click="toggleSideNav"
		:class="{ open: isSideNavOpen }"
	>
		<div class="sidenav__toggle__icon" :class="{ open: isSideNavOpen }">
			<span></span>
			<span></span>
			<span></span>
			<span></span>
		</div>
	</button>
</template>

<script setup>
const props = defineProps({
	ariaOpenSideNav: { type: String, required: false },
	ariaCloseSideNav: { type: String, required: false },
});

const store = useAppStore();

const isSideNavOpen = computed(() => store.isSideNavOpen);

function toggleSideNav() {
	store.toggleSideNav();
}
</script>

<style lang="scss">
.sidenav__toggle {
	background: none;
	border: none;
	padding: 4px 16px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: 0.25s ease-in-out;
	animation-name: toggle-anim;
	animation-duration: 0.5s;
	animation-fill-mode: forwards;

	.sidenav__toggle__icon {
		width: 26px;
		height: 20px;
		position: relative;
		transform: rotate(0deg);
		transition: 0.5s ease-in-out;

		span {
			display: block;
			position: absolute;
			height: 2.5px;
			width: 100%;
			background: var(--color-white, #fff);
			border-radius: 50px;
			opacity: 1;
			left: 0;
			transform: rotate(0deg);
			transition: 0.25s ease-in-out;
		}

		span:nth-child(1) {
			top: 0px;
		}

		span:nth-child(2) {
			opacity: 0;
		}

		span:nth-child(2),
		span:nth-child(3) {
			top: calc(50% - 2px);
		}

		span:nth-child(4) {
			top: calc(100% - 4px);
		}

		&.open span:nth-child(1) {
			top: calc(50% - 2px);
			width: 0%;
			left: 50%;
		}

		&.open span:nth-child(2) {
			transform: rotate(45deg);
			opacity: 1;
		}

		&.open span:nth-child(3) {
			transform: rotate(-45deg);
		}

		&.open span:nth-child(4) {
			top: calc(50% - 2px);
			width: 0%;
			left: 50%;
		}

		&.open span {
			background: var(--color-black, #000);
		}
	}
}
</style>
